import React, { useState } from 'react'
import Recaptcha from 'react-recaptcha'
import { withRouter } from 'react-router-dom'
import {
   FormHelperText,
   Typography,
   Grid,
   FormControl
} from '@material-ui/core'

import EmailField from '../../form/EmailField'
import SelectField from '../../form/SelectField'
import DocumentNumberField from '../../form/DocumentNumberField'
import SubmitButton from '../../form/SubmitButton'
import SecondaryButton from '../../form/SecondaryButton'
import BackButton from '../../commons/BackButton'

import { postToApi } from 'actions'
import { REGEXP } from 'utils/constants'
import { formUtils } from 'utils/utils'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { useFormValidation } from 'utils/customHooks/useFormValidation'
import { useStyles } from './styles'
import { useDocumentTypeList } from 'utils/customHooks/useDocTypesList'

const INITIAL_RECOVERY_FORM_STATE = {
   email: '',
   documentType: '',
   documentNumber: '',
   recaptcha: null
}

const INITIAL_RECOVERY_FORM_VALIDATION = {
   email: false,
   documentType: false,
   documentNumber: false,
   recaptcha: false
}

const EMAIL_MAX_LENGHT = 180
let recaptchaInstance = null

const { notRequired, lengthHigherThan, doesNotMatchRegexp } = formUtils
const isInvalidIf = {
   documentType: notRequired,
   documentNumber: notRequired,
   email: value =>
      notRequired(value) ||
      lengthHigherThan(value, EMAIL_MAX_LENGHT) ||
      doesNotMatchRegexp(value, REGEXP.EMAIL),
   recaptcha: notRequired
}

function RequestPasswordReset({ history }) {
   const classes = useStyles()

   const [formData, setFormData] = useState(INITIAL_RECOVERY_FORM_STATE)
   const [isInvalid, setIsInvalid] = useState(INITIAL_RECOVERY_FORM_VALIDATION)
   const { docTypeList, testDocLengthValidation } = useDocumentTypeList()
   const { setValue, isAnyFieldInvalid } = useFormValidation(
      [formData, setFormData],
      setIsInvalid,
      isInvalidIf
   )

   const isNotDocTypeLlength = formData.documentNumber && testDocLengthValidation(formData?.documentType, formData?.documentNumber)

   function clean() {
      setFormData(INITIAL_RECOVERY_FORM_STATE)
      setIsInvalid(INITIAL_RECOVERY_FORM_VALIDATION)
      resetRecaptcha()
   }

   async function _requestPasswordRecovery(e) {
      e.preventDefault()
      if (isAnyFieldInvalid() || isNotDocTypeLlength ) {
         return
      }
      const payload = { ...formData }
      const url = `${process.env.REACT_APP_LOGIN_API}/users/recovery-password`
      await postToApi(url, payload)
      history.push('/auth/request-password-success')
   }

   const requestPasswordRecovery = useApiRequest(
      _requestPasswordRecovery,
      'Recuperar Contraseña: Solicitar'
   )

   function resetRecaptcha() {
      recaptchaInstance.reset()
   }

   return (
      <Grid className={classes.recoveryFormContainer}>
         <BackButton to="/auth/login" />
         <Grid>
            <Typography className={classes.title}>
               Para recuperar el acceso al Portal ZonaSer:
            </Typography>
            <Typography className={classes.subtitle}>
               Proporciona los siguientes datos para comenzar
            </Typography>
         </Grid>
         <form onSubmit={requestPasswordRecovery}>
            <EmailField
               formValue={formData?.email}
               fieldInvalid={isInvalid?.email}
               handleChange={setValue}
               maxLength={EMAIL_MAX_LENGHT}
            />
            <SelectField
               fieldInvalid={isInvalid?.documentType}
               formValue={formData?.documentType}
               handleChange={evt => {
                  setValue(evt)
                  setFormData(prev => ({
                     ...prev,
                     documentNumber: ''
                  }))
               }}
               fieldLabel={'Tipo de documento *'}
               fieldName="documentType"
               errorMessage="El campo Tipo de Identificación es obligatorio."
               items={docTypeList}
            />
            <DocumentNumberField
               formValue={formData?.documentNumber}
               fieldInvalid={isInvalid?.documentNumber || isNotDocTypeLlength}
               handleChange={setValue}
               documentType={formData?.documentType}
            />
            <FormControl fullWidth className={classes.recaptchaContainer}>
               <Recaptcha
                  key="passwordRecovery-recaptcha"
                  className={classes.recaptcha}
                  ref={e => (recaptchaInstance = e)}
                  sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                  render="explicit"
                  onloadCallback={() => true}
                  verifyCallback={recaptchaToken =>
                     setValue({
                        target: { name: 'recaptcha', value: recaptchaToken }
                     })
                  }
                  expiredCallback={() =>
                     setValue({
                        target: { name: 'recaptcha', value: null }
                     })
                  }
                  hl="es-419"
               />
               {isInvalid.recaptcha && (
                  <FormHelperText className={classes.recaptchaHelperText}>
                     El Captcha es obligatorio.
                  </FormHelperText>
               )}
            </FormControl>
            <SecondaryButton text="LIMPIAR" onClick={clean} />
            <SubmitButton text="ENVIAR" />
         </form>
      </Grid>
   )
}

export default withRouter(RequestPasswordReset)
